module.exports = __webpack_public_path__ + "img/specif_eng.422a9f96.jpg";